import script from "./PartnerProjectFormStep2.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjectFormStep2.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjectFormStep2.vue?vue&type=style&index=0&id=635084c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-635084c0"]])

export default __exports__